export const brand = 'garfunkels';
export const name = 'Garfunkels';
export const braintreeDisplayName = 'Garfunkels';

export const dietLink = 'https://www.garfunkels.co.uk/allergy-info';

export const styleClasses = {
	button: 'btn'
};

export const staticDir = '/static/' + brand;



// WEBPACK FOOTER //
// ./src/brands/garfunkels/settings.js